var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-header',{staticClass:"gudin",staticStyle:{"height":"85px"}},[_c('h1',[_vm._v(" 协议规则")])]),_c('el-main',[_c('div',{staticClass:"card",domProps:{"innerHTML":_vm._s(_vm.templateHtml)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }